import { Component, OnInit , ElementRef, ViewChild} from '@angular/core';
// import { TranslateService } from '@ngx-translate/core';
import {animate, state, style, transition, trigger} from '@angular/animations';
import {  AuthService } from '../../../services/auth.service'
import { DomSanitizer, Title } from '@angular/platform-browser';
import { UntypedFormControl, FormGroupDirective, NgForm, Validators, UntypedFormGroup, FormBuilder, AbstractControl, ValidationErrors, ValidatorFn } from '@angular/forms';
import { DatePipe } from '@angular/common';
import Swal from 'sweetalert2'
import { MatDialog } from "@angular/material/dialog";
import { TermsComponent } from './../../terms/terms.component'


@Component({
  selector: 'app-web-registration',
  templateUrl: './web-registration.component.html',
  styleUrls: ['./../../home/home.component.css','./web-registration.component.css', '../../../../../../node_modules/bootstrap3/dist/css/bootstrap.min.css'],
  animations: [
    trigger('ShowHide', [
      state('spinning', style({ opacity:1 })),
      state('stopped', style({ opacity: 0, display:'none' })),
      transition('spinning => stopped', [ animate('300ms') ]),
      transition('stopped => spinning', [ animate('300ms') ]),

    ]),
  ]
})
export class WebRegistrationComponent implements OnInit {

  loaderspinning = false;
  repeatUserIdErr = false;
  termsAggred = false;

  registrationForm: UntypedFormGroup;

  @ViewChild("UserId") UserId: ElementRef;
  @ViewChild("Password") Password: ElementRef;
  @ViewChild("ConfirmPassword") ConfirmPassword: ElementRef;
  @ViewChild("FirstName") FirstName: ElementRef;
  @ViewChild("LastName") LastName: ElementRef;
  @ViewChild("COMPANY") COMPANY: ElementRef;
  @ViewChild("EMailId") EMailId: ElementRef;
  @ViewChild("MobileNo") MobileNo: ElementRef;

  @ViewChild("UserIdInput") UserIdInput: ElementRef;
  @ViewChild("PasswordInput") PasswordInput: ElementRef;
  @ViewChild("ConfirmPasswordInput") ConfirmPasswordInput: ElementRef;
  @ViewChild("FirstNameInput") FirstNameInput: ElementRef;
  @ViewChild("LastNameInput") LastNameInput: ElementRef;
  @ViewChild("COMPANYInput") COMPANYInput: ElementRef;
  @ViewChild("EMailIdInput") EMailIdInput: ElementRef;
  @ViewChild("MobileNoInput") MobileNoInput: ElementRef;


  constructor(
    // private translate: TranslateService,
    private authServObj: AuthService,
    private sanitizer: DomSanitizer,
    private datePipe:DatePipe,
    public dialog: MatDialog
  ) {
    localStorage.setItem("lang",'en')
    // translate.setDefaultLang(localStorage.getItem('lang'));
  }

  ngOnInit(): void {

    this.registrationForm = new UntypedFormGroup({
      'UserId': new UntypedFormControl(null, [Validators.required]),
      'Password': new UntypedFormControl(null, [Validators.required]),
      'ConfirmPassword': new UntypedFormControl(null, []),
      'FirstName': new UntypedFormControl(null, [Validators.required]),
      'LastName': new UntypedFormControl(null, [Validators.required]),
      'COMPANY': new UntypedFormControl(null, [Validators.required]),
      'EMailId': new UntypedFormControl(null, [Validators.required,Validators.email]),
      'MobileNo': new UntypedFormControl(null, [Validators.required]),
      'MobCode': new UntypedFormControl(null, []),
      'Phone': new UntypedFormControl(null, []),
      'PCCode': new UntypedFormControl(null, []),
    },this.confPwdValidator);


  }

  confPwdValidator(formGroup) {
    const Password = formGroup.controls.Password.value;
    const ConfirmPassword = formGroup.controls.ConfirmPassword.value;

    // 'conformErrorMsg' is the hasError('conformErrorMsg') in html file

    if(!ConfirmPassword){
      formGroup.controls.ConfirmPassword.setErrors({ required: true });
      return {required: true};
    }else{

      //formGroup.controls.ConfirmPassword.setErrors(null);
      if(Password==ConfirmPassword){
        //if true then send null
        formGroup.controls.ConfirmPassword.setErrors(null);
        return null;
      }else{
        //if false then send any object
        formGroup.controls.ConfirmPassword.setErrors({ conformErrorMsg: true });
        return {conformErrorMsg: true};
        //
      }
    }
  }

  checkRepeatedUname(){
    this.authServObj.existUsername({UserId:this.registrationForm.value.UserId.trim()}).subscribe(existUsernameRes => {
      if(!existUsernameRes.msg){
        this.repeatUserIdErr = false;
      }else{
        //this.UserId.nativeElement.scrollIntoView({ behavior: "smooth", block: "start" })
        //this.UserId.nativeElement.focus();
        this.repeatUserIdErr = true;
      }
    },error => {
      this.repeatUserIdErr = true;
      console.log(error);
    });
  }

  onRegistrationSubmit(){
    if(!this.registrationForm.get('UserId').valid){
      this.UserId.nativeElement.scrollIntoView({ behavior: "smooth", block: "start" });
      this.focusOnElem(this.UserIdInput.nativeElement,1000)
    }else if(!this.registrationForm.get('Password').valid){
      this.Password.nativeElement.scrollIntoView({ behavior: "smooth", block: "start" });
      this.focusOnElem(this.PasswordInput.nativeElement,1000);
    } else if(!this.registrationForm.get('ConfirmPassword').valid){
      this.ConfirmPassword.nativeElement.scrollIntoView({ behavior: "smooth", block: "start" });
      this.focusOnElem(this.ConfirmPasswordInput.nativeElement,1000);
    } else if(!this.registrationForm.get('FirstName').valid){
      this.FirstName.nativeElement.scrollIntoView({ behavior: "smooth", block: "start" });
      this.focusOnElem(this.FirstNameInput.nativeElement,1000);
    } else if(!this.registrationForm.get('LastName').valid){
      this.LastName.nativeElement.scrollIntoView({ behavior: "smooth", block: "start" });
      this.focusOnElem(this.LastNameInput.nativeElement,1000);
    } else if(!this.registrationForm.get('COMPANY').valid){
      this.COMPANY.nativeElement.scrollIntoView({ behavior: "smooth", block: "start" });
      this.focusOnElem(this.COMPANYInput.nativeElement,1000);
    } else if(!this.registrationForm.get('EMailId').valid){
      this.EMailId.nativeElement.scrollIntoView({ behavior: "smooth", block: "start" });
      this.focusOnElem(this.EMailIdInput.nativeElement,1000);
    }

    if(this.registrationForm.valid  && this.termsAggred ){
      this.authServObj.existUsername({UserId:this.registrationForm.value.UserId.trim()}).subscribe(existUsernameRes => {
        if(!existUsernameRes.msg){
          this.loaderspinning = true;


          this.repeatUserIdErr = false;
          let formData:FormData = new FormData();

          let finalFormData = {
            uploadedProfilePicName:"",
            uploadedBusinessPicName:"",
            uploadedProfilePicExt:"",
            uploadedBusinessPicExt:"",

            UserId:this.registrationForm.value.UserId.trim(),
            Password:this.registrationForm.value.Password,
            FirstName:this.registrationForm.value.FirstName,
            LastName:this.registrationForm.value.LastName,
            COMPANY:this.registrationForm.value.COMPANY,
            Address:"",
            EMailId:this.registrationForm.value.EMailId,
            SecondaryEMailId:"",
            MobileNo:this.registrationForm.value.MobileNo,
            Desig:"",

            ConId:0,
            StatId:0,
            CityId:0,



            ConName:"",
            StateName:"",
            CityName:"",



            PinCode:"",
            Phone:this.registrationForm.value.Phone,
            Fax:"",
            BusinessType:"",
            HowKnow:"",
            HowKnowOther:"",
            QQ_ID:"",
            SKYPE_ID:"",
            WECHAT_ID:"",
            WHATSAPP_ID:"",
            SPName:"",
            SPCODE:"",

            MobCode:this.registrationForm.value.MobCode,
            PCCode:this.registrationForm.value.PCCode,
            FCCode:"",

            Sex:""
          };
          this.authServObj.signup(finalFormData).subscribe(signupRes => {

            if(signupRes && signupRes.success){

              Swal.fire({
                icon: 'success',
                title: 'Registration done successfully.',
                showConfirmButton: false,
                timer: 2500
              })

              //this.registrationForm.reset();
              setTimeout(function () {
                window.location.reload()
              },2000)

            }
            this.loaderspinning = false;


          },error => {
            console.log(error);
          });

        }else{
          this.repeatUserIdErr = true;
        }
        if(!this.registrationForm.get('UserId').valid || this.repeatUserIdErr) {
          this.UserId.nativeElement.scrollIntoView({ behavior: "smooth", block: "start" });
          if(this.repeatUserIdErr) { this.focusOnElem(this.UserIdInput.nativeElement,1000);}
        }

      },error => {
        Swal.fire({
          icon: 'error',
          title: 'Some error occured. Please try again.',
          showConfirmButton: false,
          timer: 2500
        })
      })
    }

  }


  focusOnElem(Elem,Timeout){

    setTimeout(function () {
      Elem.focus();
    },700)

  }


  OpenTermsConPop(){
    const TCP = this.dialog.open(TermsComponent,{width:'80%',height:'80%'});
  }
}
